export const SET_PAGE_INFO = 'SET_PAGE_INFO';